module.exports = __webpack_public_path__ + "img/1.7c38af82.png";